import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';

function formatHours(value) {
    return Number.isFinite(value) ? `${value.toFixed(2)} hrs` : 'Unavailable';
}

export function AssetMaintenanceKpis({ metrics, pending, error }) {
    const cards = [
        {
            title: 'Total Maintenance Events',
            value: metrics?.maintenanceEvents ?? 'Unavailable',
        },
        {
            title: 'Total Accumulated Downtime',
            value: metrics?.downtimeHours === 0 ? '0 hrs' : formatHours(metrics?.downtimeHours),
        },
        {
            title: 'Total Spares Expenditure',
            value: metrics?.costMyr == null
                ? 'Unavailable'
                : `MYR ${metrics.costMyr.toFixed(2)}`,
        },
        {
            title: 'Mean Time Between Failures (MTBF)',
            value: metrics?.maintenanceEvents === 0 ? '0 hrs' : formatHours(metrics?.mtbfHours),
        },
        {
            title: 'Mean Time To Repair (MTTR)',
            value: metrics?.maintenanceEvents === 0 ? '0 hrs' : formatHours(metrics?.mttrHours),
        },
    ];

    return (
        <section aria-label="Maintenance metrics" className="mb-3">
            {pending && <p role="status">Loading metrics…</p>}
            {error && <Alert variant="warning">{error.message}</Alert>}
            <Row>
                {cards.map((card) => (
                    <Col key={card.title} sm={12} md={4} style={{ marginBottom: 12 }}>
                        <div style={{ border: '1px solid #e1e5ee', borderRadius: 6, padding: 16, background: '#fff' }}>
                            <div style={{ color: '#6c757d', fontSize: 13, fontWeight: 600, textTransform: 'uppercase' }}>{card.title}</div>
                            <div style={{ color: '#1f2933', fontSize: 28, fontWeight: 700, marginTop: 6 }}>{card.value}</div>
                        </div>
                    </Col>
                ))}
            </Row>
        </section>
    );
}
